import styled from '@emotion/styled'

export const Wrapper = styled.div`
  background: #fff;
  position: absolute;
  padding: 1em;
  border-radius: 0.5em;
  min-width: 250px;
  box-shadow: 0 0.25em 0.5em rgba(0, 0, 0, 0.1);
  z-index: 2;
  max-width: 90%;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`

export const FrequentList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  margin-top: 0.5em;
`

export const RecipientWrapper = styled.div`
  margin-top: 1em;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`

export const FrequentItem = styled.button`
  padding: 0.25em 0;
  display: flex;
  gap: 0.5em;
  border: none;
  background: none;
  cursor: pointer;
  white-space: pre;
  max-width: 100%;

  // Adds ellipsis if email is very long
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
